import { use, useCallback, useEffect, useState } from "react";
import ApiService from "../../services/apiService";
import { Button, Card, Container, Input, Table } from "reactstrap";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import { toast } from "react-toastify";
import { usePagination } from "../../hooks/usePagination";
import LoadingComponent from "../lodingComponent";
import { useAppSelector } from "../../reduxToolkit/hooks";

const ViewEditChakFromGroup = () => {
  const [ChakInGroup, setChakInGroup] = useState<any[]>();
  const [deviceData, setDeviceData] = useState<any[]>();
  const { Id } = useParams();
  const role = useAppSelector((state: any) => state.role.role);
  const [selected, setSelected] = useState<
    { chakId: number; groupNameMasterId: any }[]
  >([]);
  const [selectedDelete, setSelectedDelete] = useState<
    { chakId: number; groupNameMasterId: any }[]
  >([]);
  const [groupId, setGroupId] = useState<any>();
  const [refresh,setRefresh] = useState<number>(0);
  const [searchQuery,setSearchQuery] = useState<string>('')

//   const {
//     data,
//     pageNumber,
//     setPageNumber,
//     pageSize,
//     totalCount,
    
//     searchQuery,
//     setSearchQuery,
//     filterOn,
//     setSortBy,
//     loading
// } = usePagination({
//     endpoint: `/chack`,
//     filterOn:'ChackName',
//     enabled:true
    
// })

// if(data){
//    setDeviceData(data)
// }
// const totalPages = Math.ceil(totalCount / pageSize);

// const handleNext = useCallback(() => {
//     setPageNumber((prev) => Math.min(totalPages, prev + 1))
// }, [setPageNumber, totalPages])



// const handlePrev = useCallback(() => {
//     setPageNumber((prev) => Math.max(1, prev - 1))
// }, [setPageNumber, totalPages])



  const getChakInGroup = async (id: any) => {
    try {
      const response = await ApiService.axiosApi(
        `/groupinfo/get-by-masterid/${id}`,
        {
          method: "GET",
        }
      );
      if (response.success) {
        setChakInGroup(response.data);
      } else {
        console.log("unable to get chak in group");
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getChakInGroup(Id);
  }, [Id,refresh]);


  const deleteSelectedChaks = async () => {
     try {
       const response = await ApiService.axiosApi(
         `/groupinfo/delete-groupinfo`,
         {
           method: "DELETE",
           data: selectedDelete,
         }
       );
       if (response.success) {
          setRefresh(prev => prev + 1)
         toast.success("Deleted Successfully");
         
       } else {
         toast.error("Unable To Delete");
       }
     } catch (e) {
       console.log(e);
     }
   };

  const ChakAdded = async () => {
    try {
      const response = await ApiService.axiosApi(`/groupinfo/add-groupinfo`, {
        method: "POST",
        data: selected,
      });
      if (response.success) {
       
        toast.success("Chak Added to the group Successfully");
        setRefresh(prev => prev +1)
        setSelected([]);
      } else {
        toast.error("Unable to Add Chak In Group");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getDevice = async () => {
    try {
      const response = await ApiService.axiosApi(`/chack`, {
        method: "GET",
        params: {
          pageNumber: 0,
          pageSize: 0,
          filterQuery:searchQuery
        },
      });
      if (response.success) {
        setDeviceData(response.data.data);
      } else {
        console.log("unable to get device");
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDevice();
  }, [searchQuery]);

  const handleToggle = (chakId: number, groupNameMasterId?: string) => {
    setSelected((prev) => {
      const exists = prev.some((x) => x.chakId === chakId);

      if (exists) {
        // remove it
        return prev.filter((x) => x.chakId !== chakId);
      } else {
        // add new object
        return [...prev, { chakId, groupNameMasterId: Id }];
      }
    });
  };

  return (
    <>
      <Breadcrumbs
        mainTitle={"Schedule Group"}
        parent={"Schedule"}
      />
      <Card className="mb-1">
      <div className="d-flex justify-content-between align-items-center">
        <CommonCardHeader title="Chak In Group" headClass="pb-3" />
       
        <div style={{ paddingRight: "23px" }}>
        {role === "Administrator" && (
         <Button size="sm" color="danger" onClick={deleteSelectedChaks}>
         Remove
       </Button>
      )}
    
           
          </div>
        </div>
        <div style={{ maxHeight: "400px", overflowY: "auto" }} className="px-2">
          <Table bordered hover responsive className="align-middle text-center">
            <thead className="bg-light-primary">
              <tr>
                <th style={{ width: "5%" }}>
                  {/* <Input
                    type="checkbox"
                    checked={
                      (ChakInGroup?.length ?? 0) > 0 &&
                      selectedDelete.length === (ChakInGroup?.length ?? 0)
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        // Select all
                        setSelectedDelete(
                          (ChakInGroup ?? []).map((item) => ({
                            chakId: item.id,
                            groupNameMasterId: Id,
                          }))
                        );
                      } else {
                        // Deselect all
                        setSelectedDelete([]);
                      }
                    }}
                  /> */}
                </th>
                <th style={{ fontSize: "15px" }}>DeviceType</th>
                <th style={{ fontSize: "15px" }}>Chak Name</th>
                <th style={{ fontSize: "15px" }}>Chak Area</th>
                <th style={{ fontSize: "15px" }}>Scheme/Village</th>
                <th style={{ fontSize: "15px" }}>Distributary/Zone</th>
                <th style={{ fontSize: "15px" }}>Wua</th>
              </tr>
            </thead>
            <tbody>
              {ChakInGroup?.map((item) => (
                <tr key={item.id}>
                  <td>
                    <Input
                      type="checkbox"
                      checked={selectedDelete.some(
                        (x) => x.chakId === item.chakId
                      )}
                      onChange={() => {
                        setSelectedDelete((prev) => {
                          const exists = prev.some(
                            (x) => x.chakId === item.chakId
                          );
                          if (exists) {
                            // Remove this row from selected
                            return prev.filter((x) => x.chakId !== item.chakId);
                          } else {
                            // Add this row to selected
                            return [
                              ...prev,
                              {
                                chakId: item.chakId,
                                groupNameMasterId: Id,
                              },
                            ];
                          }
                        });
                      }}
                    />
                  </td>

                  <td>{item.deviceType}</td>
                  <td>{item.chakName}</td>
                  <td>{item.chakArea}</td>
                  <td>{item.schemeVillage}</td>
                  <td>{item.distributaryZone}</td>
                  <td>{item.headQuaterName}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      <Card>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
          <CommonCardHeader title="Add Chak" headClass="pb-3" />
          <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           
                       }}
                      
                        />
                        </div>

                        </div>
          <div style={{ paddingRight: "23px" }}>
          {role === "Administrator" && (
            <Button size="sm" color="primary" onClick={ChakAdded}>
            Add
          </Button>
        
      )}
    
            
          </div>
        </div>
        <div style={{ maxHeight: "400px", overflowY: "auto" }} className="px-2">
          <Table bordered hover responsive className="align-middle text-center">
            <thead className="bg-light-primary">
              <tr>
                <th style={{ width: "5%" }}>
                  {/* <Input
                    type="checkbox"
                    checked={
                      (deviceData?.length ?? 0) > 0 &&
                      selected.length === (deviceData?.length ?? 0)
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelected(deviceData?.map((item) => item.id) || []);
                      } else {
                        setSelected([]);
                      }
                    }}
                  /> */}
                </th>
                <th style={{ fontSize: "15px" }}>Device Type</th>
                <th style={{ fontSize: "15px" }}>Chak Name</th>
                <th style={{ fontSize: "15px" }}>Chak Area</th>
                <th style={{ fontSize: "15px" }}>Scheme/Village</th>
                <th style={{ fontSize: "15px" }}>Distributary/Zone</th>
              </tr>
            </thead>
            <tbody>
              {(deviceData?.length ?? 0) > 0 ? (
                deviceData?.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <Input
                        type="checkbox"
                        checked={selected.some((x) => x.chakId === item.id)}
                        onChange={() => handleToggle(item.id, Id)}
                      />
                    </td>
                    <td>{item.deviceType}</td>
                    <td>{item.chackName}</td>
                    <td>{item.chackArea}</td>
                    <td>{item.scheme_Village}</td>
                    <td>{item.distributary_Zone}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center text-muted">
                  <LoadingComponent/>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card>
    </>
  );
};
export default ViewEditChakFromGroup;
